import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import logoWhite from '../../images/logo/UPP-Logotype-Landscape-White-Transparent.png';

const PublicPageNavbar = () => (
    <Navbar expand="lg" className='public-page-navbar'>
        <Container fluid>
            <Navbar.Brand href="/">
                <img src={ logoWhite } title="Upprovall" alt="Upprovall" height="20" />
            </Navbar.Brand>
        </Container>
    </Navbar>
);

export default PublicPageNavbar;